import type {
  CustomerDraft,
  ImportContext,
  ImportGateway,
  ImportResult,
  MachineDraft,
} from '@forq/import-data';

/**
 * Demo-Modus: übernimmt in den Speicher, damit die Fläche ohne Supabase erlebbar ist.
 * Bewusst mit denselben Regeln wie die Datenbank -- Nummer ist der Schlüssel, ein zweiter
 * Durchlauf aktualisiert statt zu verdoppeln. Sonst zeigt der Demo-Modus etwas, das die echte
 * Übernahme nicht tut.
 */
export class DemoImportGateway implements ImportGateway {
  private readonly customers = new Map<string, { id: string; number: string; name: string }>();
  private readonly machineNumbers = new Set<string>();

  constructor(private readonly types: readonly { readonly id: string; readonly name: string }[]) {}

  async loadContext(): Promise<ImportContext> {
    return {
      customers: [...this.customers.values()],
      machineNumbers: [...this.machineNumbers],
      machineTypes: this.types,
    };
  }

  async importCustomers(_tenantId: string, drafts: readonly CustomerDraft[]): Promise<ImportResult> {
    let created = 0;
    let updated = 0;
    for (const draft of drafts) {
      if (this.customers.has(draft.number)) updated += 1;
      else created += 1;
      this.customers.set(draft.number, {
        id: `demo-${draft.number}`,
        number: draft.number,
        name: draft.companyName ?? [draft.firstName, draft.lastName].filter(Boolean).join(' '),
      });
    }
    return { created, updated };
  }

  async importMachines(_tenantId: string, drafts: readonly MachineDraft[]): Promise<ImportResult> {
    let created = 0;
    let updated = 0;
    for (const draft of drafts) {
      if (this.machineNumbers.has(draft.number)) updated += 1;
      else created += 1;
      this.machineNumbers.add(draft.number);
    }
    return { created, updated };
  }
}

export function createDemoImportGateway(
  types: readonly { readonly id: string; readonly name: string }[],
): ImportGateway {
  return new DemoImportGateway(types);
}
